module.exports = __webpack_public_path__ + "img/home_pic_spgl.88dfaa27.png";